// Mark wishlist page globally (so CSS can target it)
(function () {
  const isWishlistPage =
    location.pathname === '/pages/wishlist' ||
    location.pathname.endsWith('/pages/wishlist');

  document.documentElement.classList.toggle('sxt-wishlist-page', isWishlistPage);
})();

(function () {
  const KEY = "sxt_wishlist";

  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); }
    catch { return []; }
  }

  function setList(arr) {
    localStorage.setItem(KEY, JSON.stringify(arr));
    updateCount();
  }

  function hasHandle(handle) {
    return getList().includes(handle);
  }

  function toggleHandle(handle) {
    const list = getList();
    const i = list.indexOf(handle);
    if (i >= 0) list.splice(i, 1);
    else list.unshift(handle);
    setList(list);
    setActiveUI(handle);
    renderWishlistPage(); // ако сме на wishlist page
  }

  function money(value) {
    const cents = Number(value || 0);
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      const fmt = (window.theme && window.theme.moneyFormat) ? window.theme.moneyFormat : "{{amount}}";
      return window.Shopify.formatMoney(cents, fmt);
    }
    return (cents / 100).toFixed(2);
  }

  function updateCount() {
    const count = getList().length;
    document.querySelectorAll("[data-sxt-wishlist-count]").forEach((el) => {
      el.textContent = String(count);
      el.style.display = count > 0 ? "inline-flex" : "none";
    });
  }

  function setActiveUI(handle) {
    document.querySelectorAll(`[data-sxt-wishlist-btn][data-handle="${handle}"]`).forEach((btn) => {
      btn.classList.toggle("is-active", hasHandle(handle));
    });
  }

  // Bind all buttons (product page + cards)
  function bindButtons() {
    document.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-sxt-wishlist-btn]");
      if (!btn) return;
      e.preventDefault();
      const handle = btn.getAttribute("data-handle");
      if (!handle) return;
      toggleHandle(handle);
    });
  }

  // Wishlist page renderer
  async function fetchProduct(handle) {
    const res = await fetch(`/products/${handle}.js`, { credentials: "same-origin" });
    if (!res.ok) throw new Error("Product fetch failed: " + handle);
    return res.json();
  }

  function ensureTrack() {
    // Търсим контейнер на wishlist page.
    // Ако имаш вече <div id="wishlist"> или подобно – добави data атрибут там:
    // data-sxt-wishlist-root
    let root = document.querySelector("[data-sxt-wishlist-root]");
    if (!root) root = document.querySelector("#wishlist") || document.querySelector(".wishlist") || document.querySelector("main");
    if (!root) return null;

    let track = root.querySelector(".sxt-wishlist-track");
    if (!track) {
      track = document.createElement("div");
      track.className = "sxt-wishlist-track";
      root.appendChild(track);
    }
    return track;
  }

  function cardHTML(p) {
    const price = p.price; // cents
    const compare = p.compare_at_price; // cents or null
    const onSale = compare && compare > price;
    const pct = onSale ? Math.round(((compare - price) * 100) / compare) : 0;

    const img = (p.images && p.images.length) ? p.images[0] : "";
    const url = p.url;

    return `
      <article class="sxt-wishlist-card">
        <a class="sxt-wishlist-card__media" href="${url}">
          ${img ? `<img src="${img}" alt="${(p.title || "").replace(/"/g, "&quot;")}" loading="lazy">` : ``}
        </a>
        <div class="sxt-wishlist-card__body">
          <h3 class="sxt-wishlist-card__title">
            <a href="${url}">${p.title || ""}</a>
          </h3>

          <div class="sxt-wishlist-card__price">
            <span class="now">${money(price)}</span>
            ${onSale ? `<span class="was">${money(compare)}</span>` : ``}
            ${onSale ? `<span class="pct">-${pct}%</span>` : ``}
          </div>

          <div class="sxt-wishlist-card__actions">
            <button type="button" class="is-danger" data-sxt-wishlist-remove data-handle="${p.handle}">Премахни</button>
            <a href="${url}">Виж продукта</a>
          </div>
        </div>
      </article>
    `;
  }

  async function renderWishlistPage() {
    const track = ensureTrack();
    if (!track) return;

    const handles = getList();
    if (!handles.length) {
      track.innerHTML = `<div style="padding:12px 0;opacity:.7;">Нямаш добавени продукти в любими.</div>`;
      return;
    }

    track.innerHTML = `<div style="padding:12px 0;opacity:.7;">Зареждане...</div>`;

    try {
      const products = await Promise.all(handles.map(fetchProduct));
      track.innerHTML = products.map(cardHTML).join("");

      // remove buttons
      track.querySelectorAll("[data-sxt-wishlist-remove]").forEach((btn) => {
        btn.addEventListener("click", () => {
          const h = btn.getAttribute("data-handle");
          const list = getList().filter(x => x !== h);
          setList(list);
          renderWishlistPage();
          // update active hearts on page if any
          document.querySelectorAll(`[data-sxt-wishlist-btn][data-handle="${h}"]`).forEach(b => b.classList.remove("is-active"));
        });
      });

    } catch (err) {
      track.innerHTML = `<div style="padding:12px 0;opacity:.7;">Грешка при зареждане на продуктите.</div>`;
      console.error(err);
    }
  }

  // Init
  bindButtons();
  document.addEventListener("DOMContentLoaded", () => {
    updateCount();

    // set active on all visible buttons
    document.querySelectorAll("[data-sxt-wishlist-btn]").forEach((btn) => {
      const h = btn.getAttribute("data-handle");
      if (h) btn.classList.toggle("is-active", hasHandle(h));
    });

    // render wishlist page if we are on it
    renderWishlistPage();
  });

})();
